import { createModelPermissions } from 'components/permissions/utils/model-permission-generator';

const ExhibitionConst = createModelPermissions({
  modelName: 'exhibition_types',
  basePath: '/exhibition-types',
  permissions: {
    VIEW: true,
    UPDATE: true,
    DELETE: true,
    CHANGE_STATUS: true
  }
});

export default ExhibitionConst;
